import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis } from "@/lib/lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Skills } from "@/components/Skills";
import { Projects } from "@/components/Projects";
import { Timeline } from "@/components/Timeline";
import { BeyondCode } from "@/components/BeyondCode";
import { AiPlayground } from "@/components/AiPlayground";
import { ChatWidget } from "@/components/ChatWidget";
import { CursorGlow } from "@/components/CursorGlow";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { motion, useScroll, useSpring } from "framer-motion";

function App() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 25 });

  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App font-sans" data-testid="portfolio-app">
      <motion.div
        data-testid="scroll-progress-bar"
        className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-gradient-to-r from-cyan-400 via-violet-500 to-cyan-400"
        style={{ scaleX: progress }}
      />
      <CursorGlow />
      <ChatWidget />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Skills />
        <Projects />
        <Timeline />
        <BeyondCode />
        <AiPlayground />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0D0E15",
            border: "1px solid rgba(139, 92, 246, 0.3)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}

export default App;
